import BoldData from "../../viewmodel/mindelementdata/mindcontent/BoldData";
import TextStyleCell from "../../viewmodel/mindelementdata/mindcontent/TextStyleCell";

class MindmapSDKTextStyleCell {
    constructor() {
        this.startIndex = 0;
        this.endIndex = 0;

        this.textColor = -10000;
        this.textFontSize = 0;
        this.bgColor = -10000;
        this.textBold = false;
    }

    toTextStyleCell() {
        let data = new TextStyleCell();
        data.startIndex = this.startIndex;
        data.endIndex = this.endIndex;

        data.textColor = this.textColor <= 1 && this.textColor != -10000 ? 0x000002 : this.textColor;
        data.textFontSize = this.textFontSize;
        data.bgColor = this.bgColor <= 1 && this.bgColor != -10000 ? 0x000002 : this.bgColor;
        let bold = new BoldData()
        bold.setValue(this.textBold)
        data.textBold = bold;
        return data;
    }
}
export default MindmapSDKTextStyleCell